import { v4 as uuidv4 } from 'uuid'

export const threeYearAvgNNAGrowthTestData = () => {
  return {
    title: '3-Year Avg. NNA Growth',
    item: '9%',
    key: uuidv4()
  }
}
